import { manifestApi } from '../../api/manifestApi.js'

import { utgManifestSignal, utgManifestLoadedSignal, utgManifestErrorSignal } from '../signals/utgManifestSignals.js'

export const fetchUtgManifest = async (config, accessToken) => {
    utgManifestLoadedSignal.value = false
    utgManifestSignal.value = null
    return await manifestApi.fetchUTGManifest(config, accessToken).then(
        (utgManifest) => {
            utgManifestSignal.value = utgManifest
            utgManifestLoadedSignal.value = true
            return utgManifestSignal.value
        }
    ).catch(
        (err) => {
            utgManifestErrorSignal.value = err
            throw err
        }
    )
}